import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import "./PlantationTwoOffer.scss";
import PGLoaders from "../../../../default-pages/PGLoaders/PGLoaders";

import firebase from "firebase/app";
import "firebase/firestore";

import AddOffers from "../../../../default-hooks/AddOffers";
import { useAuthContext } from "../../../../firebase-files/hooks/useAuthContext";
import { useDocument } from "../../../../firebase-files/hooks/useDocument";
import { useCollection } from "../../../../firebase-files/hooks/useCollection";

const PlantationTwoOffer = () => {
  const { user } = useAuthContext();

  const [isAdmin, setIsAdmin] = useState(false);
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);

  const [apptype, setAppType] = useState("");

  const { document: appTypeDoc } = useDocument("settings", "AppType");
  const { documents: users } = useCollection("users");

  // const [appType, setAppType] = useState("lite");
  const [userRole, setUserRole] = useState("");

  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [deleting, setDeleting] = useState(false);

 // ✅ check if current user is admin or superAdmin
  useEffect(() => {
    if (!user || !users) {
      setIsAdmin(false);
      setIsSuperAdmin(false);
      return;
    }

    const phone = user?.phoneNumber?.replace("+91", "91");
    const userInfo = users.find((u) => u.id === phone);

    if (userInfo) {
      setIsAdmin(userInfo.role?.toLowerCase() === "admin");
      setIsSuperAdmin(userInfo.role?.toLowerCase() === "superadmin");
    } else {
      setIsAdmin(false);
      setIsSuperAdmin(false);
    }
  }, [user, users]);


  // ✅ load app type from appTypeDoc if available
  useEffect(() => {
    if (appTypeDoc && appTypeDoc.apptype) {
      setAppType(appTypeDoc.apptype);
    }
  }, [appTypeDoc]);

  const canManageOffers = () => {
    if (apptype === "lite" && isSuperAdmin) return true;
    if (apptype === "pro" && (isSuperAdmin || isAdmin)) return true;
    return false;
  };

  const canDeleteOffers = userRole === "superadmin";

  // 🔹 Load offers
  useEffect(() => {
    const db = firebase.firestore();

    const unsubscribe = db
      .collection("offers")
      .orderBy("createdAt", "desc")
      .onSnapshot(
        (snapshot) => {
          const fetchedOffers = snapshot.docs
            .map((doc) => ({ id: doc.id, ...doc.data() }))
            .filter((doc) => doc.imageURL);

          setOffers(fetchedOffers);
          setLoading(false);
        },
        (error) => {
          console.error("Firestore error:", error.message);
          setLoading(false);
        }
      );

    return () => unsubscribe();
  }, []);

  const displayedOffers =
    offers.length >= 3
      ? offers
      : Array(3)
          .fill(offers)
          .flat()
          .slice(0, 3);

  const settings = {
    dots: false,
    infinite: true,
    speed: 800,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2500,
    arrows: false,
    responsive: [{ breakpoint: 768, settings: { slidesToShow: 1 } }],
  };

  const handleDeleteClick = (offerId) => {
    setDeleteTarget(offerId);
  };

  const confirmDelete = async () => {
    if (!deleteTarget) return;
    setDeleting(true);

    try {
      const db = firebase.firestore();
      await db.collection("offers").doc(deleteTarget).delete();
      setDeleteTarget(null);
    } catch (error) {
      console.error("Error deleting offer:", error);
    } finally {
      setDeleting(false);
    }
  };

  const cancelDelete = () => {
    setDeleteTarget(null);
  };

  return (
    <div className="plantation-two-offer">
      <div style={{ marginBottom: "20px", textAlign: "right" }}>
        {/* AddOffers itself also gates its button; keeping here is fine */}
        <AddOffers />
      </div>

      {loading ? (
        <p style={{ textAlign: "center" }}>
          <PGLoaders />
        </p>
      ) : offers.length > 0 ? (
        <Slider {...settings}>
          {displayedOffers.map((offer, i) => (
            <div key={offer.id + i} className="offer-slide" style={{ position: "relative" }}>
              <img
                src={offer.imageURL}
                alt={`Offer ${i + 1}`}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "/assets/img/default.jpg";
                }}
              />

              {/* Show delete icon only when allowed by plan+role */}
              {canDeleteOffers && (
                <div
                  className="delete-icon"
                  title="Delete Offer"
                  onClick={() => handleDeleteClick(offer.id)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="20"
                    viewBox="0 0 24 24"
                    width="20"
                    fill="#d32f2f"
                  >
                    <path d="M3 6h18v2H3V6zm2 3h14l-1.5 12.5a1 1 0 01-1 .5H7a1 1 0 01-1-.5L4 9zm5 2v8h2v-8H9zm4 0v8h2v-8h-2zM9 4h6v2H9V4z" />
                  </svg>
                </div>
              )}
            </div>
          ))}
        </Slider>
      ) : (
        <p style={{ textAlign: "center" }}>No offers available currently.</p>
      )}

      {deleteTarget && (
        <div className="delete-popup">
          <div className="popup-box">
            <p>Are you sure you want to delete this offer?</p>
            <div className="popup-buttons">
              <button
                onClick={confirmDelete}
                disabled={deleting}
                style={{ opacity: deleting ? 0.6 : 1 }}
              >
                {deleting ? "Deleting..." : "Delete"}
              </button>
              <button onClick={cancelDelete} disabled={deleting}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PlantationTwoOffer;
